export default "https://cdn-static.gokick.com/assets/bf292cd7043bd3c72a48f3c1f30d1b93bc9276ca/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";